exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 320px) and (max-width: 580px) {\n.header-subtotal .sub-total-details {\n    margin-top: 0;\n}\n}", ""]);

// exports
